import { render, staticRenderFns } from "./FlexibleCombo.vue?vue&type=template&id=4cc53f5a&scoped=true&"
import script from "./FlexibleCombo.vue?vue&type=script&lang=js&"
export * from "./FlexibleCombo.vue?vue&type=script&lang=js&"
import style0 from "./FlexibleCombo.vue?vue&type=style&index=0&id=4cc53f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc53f5a",
  null
  
)

export default component.exports